module.exports = __webpack_public_path__ + "static/media/session-expired-mobile.dde13f54.svg";